<template>
  <div id="myDnloadHomeDetail">
    <div>
      <div class="m_t_10 m_b_20">
        <!-- <div class="dis_line dnlDetDivTop">
          <div class="suerButton dis_line c_p">
            <span>导出</span>
          </div>
          <div class="dnlDetDiv">
            <div>
              <button @click="allUpdow('excel')" :disabled="isBtn">excel</button>
            </div>
            <div>
              <button @click="allUpdow('csv')" :disabled="isBtn">csv</button>
            </div>
          </div>
        </div> -->
        <!-- <button @click="seltGenre(2)" class="suerButton v_m m_l_10">
          <span>发送</span>
        </button>
        <button @click="seltGenre(1)" class="suerButton v_m m_l_10">
          <span>订阅</span>
        </button> -->
        <span @click="$commonJs.backURL" class="btn-back">
          <span>返回</span>
        </span>
      </div>
      <div class="allDl m_t_20 d_flex" id="topSerchDiv">
        <dl class="search-downDl allDl_span80" style="width: calc(100% - 50px)">
          <dd
            :key="index"
            v-for="(item, index) in mySerchTop"
            v-if="item.isMustFilter || item.isCanSeletion"
          >
            <span class="search-label">{{ item.displayColumnName }}:</span><div class="search-input">
              <allSelect
                @clickValue="getValueList(item)"
                v-if="item.fieldType !== 'Datetime'"
                v-model="item.valueData"
                :multiple="!item.isSingleChoice"
                :chooseData="item.childList"
                :needReturn="'id'"
                :matchValue="'name'"
                :showValue="'{{name}}'"
                :width="'100%'"
                :placeholder="'全部'"
                :borderLine="'#E5E5E5'"
              ></allSelect>
              <div class="d_flex" v-if="item.fieldType === 'Datetime'">
                <div style="width: 45%">
                  <cander v-model="item.startTime" :className="'allInput'" :newWidth="'100%'"></cander>
                </div>
                <div class="t_c" style="width: 40px">至</div>
                <div style="width: 45%">
                  <cander
                    :minDate="item.startTime"
                    v-model="item.endTime"
                    :className="'allInput'"
                    :newWidth="'100%'"
                  ></cander>
                </div>
              </div>
            </div>
          </dd>
          <dd v-if="IsHasUnit">
            <span class="search-label">单位:</span><div class="search-input">
              <allSelect
                v-model="unitSelected"
                :chooseData="unitList"
                :multiple="false"
                :needReturn="'id'"
                :matchValue="'name'"
                :showValue="'{{name}}'"
                :width="'100%'"
                :placeholder="'全部'"
                :borderLine="'#E5E5E5'"
              ></allSelect>
            </div>
          </dd>
          <dt style="width: auto;">
            <button  class="greenButton BtnCustom" @click="clkModel(2)" v-if="IsCustomize">
              <span>自定义列</span>
              <i class="icon-more"></i>
            </button>
            <button  class="greenButton BtnMore"  @click="clkModel(1)">
              <span>更多搜索条件</span>
            </button>
            <button @click="confSerch()" class="suerButton">
              <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
              <span class="m_l_5">搜索</span>
            </button>
          </dt>
        </dl>
      </div>
      <div class="btn-group">
        <div class="group-lf"><span class="total">找到 {{ myList.totalCount }} 条数据</span>
        <span class="dnlDetDivTop">
          <span class="btn-export"></span>
          <div class="dnlDetDiv">
            <div>
              <button @click="allUpdow('excel')" :disabled="isBtn">excel</button>
            </div>
            <div>
              <button @click="allUpdow('csv')" :disabled="isBtn">csv</button>
            </div>
          </div>
        </span>
        </div>
        <div class="group-rt"><span class="btn-notice" @click="clkModel(3)">说明</span><span class="btn-send" @click="seltGenre(2)">发送</span><span class="btn-subscribe" @click="seltGenre(1)">订阅</span></div>
      </div>
      <!-- <p class="d_flex back_colorhuiDADADA" >
        <span>请点击“导出”按钮下载查看全部数据内容！</span>
        <span>最新更新时间：{{ myList.lastSyncTime }}</span>
      </p> -->
       <!--
      <p v-if="this.dowFileName=='Wellness Underlying'" class="d_flex back_colorhuiDADADA" >
        <span>提示：由于KA type新增"NRT"，T3nonchain部分外层逻辑调整中。</span>
      </p>
      -->
      
      <p v-if="this.dowFileName=='Endcon'||this.dowFileName=='Underlying'" class="d_flex back_colorhuiDADADA" style="padding: 0px 50px 5px 50px;">
        <span>提示：目前winbi系统已上线，Portal不再提供25年UL/ENDCON数据服务，请前往：<a href="https://winbi.haleon.cn/" target="_blank" >Haleon 客户数据管理平台</a>，下载相关数据</span>
        <span>最新更新时间：{{ myList.lastSyncTime }}</span>
      </p>
      <div v-else-if="this.dowFileName=='NKA POS'">
      <p class="d_flex back_colorhuiDADADA" style="padding: 0px 50px 5px 50px;">
        <span>提示：本报告依据当月主数据形成每月的结存版数据，如希望看到根据26年1月主数据倒刷后的25年历史月份POS数据，请至CCDM Portal POS明细报告下载。链接: <a href="https://ccdm.haleon.cn/analysis-report/pos-detail-report" target="_blank" >Portal-POS明细报告</a></span>
      </p>
      <p class="d_flex back_colorhuiDADADA" style="padding: 0px 50px 5px 50px;">
        <span>请点击“导出”按钮下载查看全部数据内容！</span>  
        <span>最新更新时间：{{ myList.lastSyncTime }}</span>
      </p>
      </div>
     <p v-else class="d_flex back_colorhuiDADADA" >
        <span>请点击“导出”按钮下载查看全部数据内容！</span>
        <span>最新更新时间：{{ myList.lastSyncTime }}</span>
      </p>
      <div style="overflow: auto" :style="{'max-height': tableHeight + 'px'}">
        <table class="allTable" cellspacing="0">
          <thead>
            <tr>
              <th
                :key="indexF"
                v-for="(itemF, indexF) in myList.columns"
                style="text-align: left;"
              >{{ itemF }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="myList.datas.length === 0">
              <td :colspan="myList.columns.length">暂无数据</td>
            </tr>
            <tr v-if="myList.datas.length > 0" :key="index" v-for="(item, index) in myList.datas">
              <td :key="indexC" v-for="(itemC, indexC) in item" class="t_l">{{itemC}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div class="linDivR">
      <div @click="clkModel(2)" v-if="IsCustomize">
        <i class="icon iconfont iconcustomize"></i>
        <p>自定义列</p>
      </div>
      <div @click="clkModel(1)">
        <i class="icon iconfont icontiaojianguolv"></i>
        <p>搜索条件</p>
      </div>
      <div @click="clkModel(3)">
        <i class="icon iconfont iconbangzhu"></i>
        <p>说明</p>
      </div>
    </div> -->
    <!---->
    <modelRight
      ref="modelRight1"
      v-if="showModel"
      :title="title"
      :minWidth="'35%'"
      :onButton="1"
      :mlData="mlData"
      @sletModelId="sletModelId($event)"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="confSerch()"
      v-on:on-resetModel="resetSerch()"
    >
      <div class="dnlUl" style="height: 100%;overflow:auto">
        <ul>
          <li
            :class="parseInt(leftIndexNum) === parseInt(index) ? 'back_colorYellowfddfcf' : ''"
            :key="index"
            v-for="(item, index) in mySerchList"
            v-if="item.isMustFilter || item.isCanSeletion"
          >
            <span>{{ item.displayColumnName }}：</span>
            <div class="v_m">
              <allSelect
                @clickValue="getValueList(item)"
                v-if="parseInt(item.dataDicValueCount) <= 100 && item.fieldType !== 'Datetime'"
                :multiple="!item.isSingleChoice"
                :showSerch="true"
                v-model="item.valueData"
                :chooseData="item.childList"
                :needReturn="'id'"
                :matchValue="'name'"
                :showValue="'{{name}}'"
                :width="'100%'"
                :placeholder="'全部'"
                :borderLine="'#E5E5E5'"
              ></allSelect>
              <div
                v-if="parseInt(item.dataDicValueCount) > 100 && item.fieldType !== 'Datetime'"
                class="dnlLeft NoWrap c_p"
                @click="seltModel(item, index)"
              >
                <p class="dis_line v_m" v-if="item.valueDataMd.length === 0">
                  <span style="color: rgb(125, 125, 125)">全部</span>
                </p>
                <p
                  class="dis_line v_m"
                  :key="leftIndex"
                  v-for="(leftItem, leftIndex) in item.valueDataMd"
                  v-if="item.valueDataMd.length > 0"
                >
                  <abbr v-if="leftIndex !== 0">,</abbr>
                  <span>{{ leftItem.name }}</span>
                </p>
              </div>
              <div class="d_flex" v-if="item.fieldType === 'Datetime'">
                <div style="width: 45%">
                  <cander v-model="item.startTime" :className="'allInput'" :newWidth="'100%'"></cander>
                </div>
                <div class="t_c" style="width: 40px">至</div>
                <div style="width: 45%">
                  <cander
                    :minDate="item.startTime"
                    v-model="item.endTime"
                    :className="'allInput'"
                    :newWidth="'100%'"
                    :isBear="true"
                  ></cander>
                </div>
              </div>
            </div>
          </li>
          <!--<li>-->
          <!--  <span>月份：</span>-->
          <!--  <div class="v_m">-->
          <!--    <allSelect :multiple="true" v-model="seltFmouth" :chooseData="fileMouth" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
          <!--    </allSelect>-->
          <!--  </div>-->
          <!--</li>-->
          <!--<li>-->
          <!--  <span>BU：</span>-->
          <!--  <div class="v_m">-->
          <!--    <allSelect :multiple="true" v-model="seltFmouth" :chooseData="fileMouth" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
          <!--    </allSelect>-->
          <!--  </div>-->
          <!--</li>-->
          <!--<li>-->
          <!--  <span>ULchannel：</span>-->
          <!--  <div class="v_m">-->
          <!--    <input @click="seltModel()" type="text" readonly class="allInput" style="width: calc(100% - 12px)"/>-->
          <!--  </div>-->
          <!--</li>-->
        </ul>
      </div>
    </modelRight>
    <modelRight
      v-if="showModel1"
      :title="title1"
      :minWidth="'40%'"
      :onButton="2"
      v-on:on-cancel="showModel1 = false"
      v-on:on-confirm="confColumn()"
      v-on:on-resetModel="resetSort()"
    >
      <div class="ribbonDiv">
        <div>
          <nav class="d_flex">
            <span class="font14 f_w">可选列</span>
            <button style="visibility: hidden" class="suerButton">
              <span>按默认排序</span>
            </button>
          </nav>
          <p style="margin: 0 1em 1em;">
            <input
              @change="seltAllWide()"
              v-model="isCheckAll"
              type="checkbox"
              class="allCheckbox"
              id="ribbonCheck_all"
            />
            <label for="ribbonCheck_all"></label>
            <label for="ribbonCheck_all">
              <span
                class="dis_line v_m NoWrap c_p colorGray696969"
                style="width: calc(100% - 40px)"
              >全选</span>
            </label>
          </p>
          <div>
            <ul>
              <li class="m_b_10" :key="index" v-for="(item, index) in myWideTableFilterList">
                <input
                  @change="seltWide(item, index)"
                  v-model="item.isOpenClick"
                  type="checkbox"
                  class="allCheckbox"
                  :id="'ribbonCheck' + index"
                  :disabled="item.isMustShow"
                />
                <label :for="'ribbonCheck' + index"></label>
                <label :for="'ribbonCheck' + index">
                  <span
                    class="dis_line v_m NoWrap c_p colorGray696969"
                    style="width: calc(100% - 40px)"
                  >{{ item.displayColumnName }}</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <nav class="d_flex">
            <span class="font14 f_w">已选列</span>
            <span @click="seltDefaultSort()" class="btn-sort">
              <span>按默认排序</span>
            </span>
          </nav>
          <p style="margin: 0 1em 1em; visibility: hidden">
            <input
              @change="seltAllWide()"
              v-model="isCheckAll"
              type="checkbox"
              class="allCheckbox"
              id="ribbonCheck_all"
            />
            <label for="ribbonCheck_all"></label>
            <label for="ribbonCheck_all">
              <span
                class="dis_line v_m NoWrap c_p colorGray696969"
                style="width: calc(100% - 40px)"
              >全选</span>
            </label>
          </p>
          <div>
            <draggable
              tag="ul"
              :list="mySelectedColumnList"
              :move="checkMove"
              v-bind="{animation: 300,handle:'.moveIcon'}"
            >
              <li class="m_b_10" :key="index" v-for="(item, index) in mySelectedColumnList">
                <i
                  class="icon iconfont iconcaidan moveIcon colorYellowF36A20"
                  style="cursor: grabbing"
                  title="上下拖动"
                ></i>
                <span
                  class="dis_line v_m NoWrap c_p colorGray696969"
                  style="width: calc(100% - 20px)"
                >{{ item.displayColumnName }}</span>
              </li>
            </draggable>
          </div>
        </div>
      </div>
    </modelRight>
    <modelRight
      v-if="showModel2"
      :title="title2"
      :minWidth="'50%'"
      :onButton="0"
      v-on:on-cancel="showModel2 = false"
    >
      <div style="height: 100%;overflow: auto;padding: 0 10px">
        <div class="m_b_10">
          <textarea
            v-model="mydbDescribe"
            rows="5"
            class="allTextarea"
            readonly
            style="width: calc(100% - 12px);background-color: transparent"
          ></textarea>
        </div>
        <div>
          <table class="allTable" cellspacing="0">
            <thead>
              <tr>
                <th style="text-align: left">名称</th>
                <th style="text-align: left">说明</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(item, index) in myInstructionsFilterList">
                <td style="text-align: left">{{ item.displayColumnName }}</td>
                <td style="text-align: left">{{ item.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modelRight>
    <model
      v-if="showModel3"
      :title="title3"
      :minWidth="'60%'"
      :onButton="1"
      v-on:on-cancel="showModel3 = false"
      v-on:on-confirm="confirmSuCriber"
    >
      <div class="pd_10_20">
        <div class="dnlUl" style="max-height: 70vh;overflow: auto">
          <ul>
            <li>
              <span style="vertical-align: top">已选参数：</span>
              <div>
                <div class="dnlUl_par">
                  <p
                    :key="index"
                    v-for="(item, index) in subscriptionData.parameterJsonList"
                  >{{ item }}</p>
                </div>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅名称:</span>
              <div>
                <input
                  v-model="subscriptionData.subscribeName"
                  type="text"
                  class="allInput"
                  style="width: calc(100% - 12px)"
                />
              </div>
            </li>
            <li>
              <span style="vertical-align: top;margin-top: 5px">邮箱地址：</span>
              <div>
                <section class="dnlUl_emlS">
                  <input @input="seltEmail()" v-model="serchEamil" type="text" placeholder="请输入..." />
                  <div v-if="serchEamil !== ''">
                    <div v-if="allEmailList.length === 0">未找到任何结果</div>
                    <p
                      @click="pickEmail(item, 1)"
                      class="NoWrap"
                      :key="index"
                      v-for="(item, index) in allEmailList"
                    >{{ item }}</p>
                    <p
                      @click="pickEmail('', 2)"
                      class="NoWrap"
                      v-if="allEmailList.length === 0"
                    >{{ serchEamil }}</p>
                  </div>
                </section>
                <div class="dnlUl_eml">
                  <div :key="index" v-for="(item, index) in subscriptionData.subscribeEmails">
                    <span class="m_r_10">{{ item }}</span>
                    <i
                      @click="eraseEmail(index)"
                      class="icon iconfont iconguanbi colorYellowF36A20"
                    ></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <span>邮箱标题:</span>
              <div>
                <input
                  v-model="subscriptionData.subscribeTitle"
                  type="text"
                  class="allInput"
                  style="width: calc(100% - 12px)"
                />
              </div>
            </li>
            <li>
              <span>正文：</span>
              <div>
                <textarea
                  v-model="subscriptionData.subscribeBody"
                  rows="5"
                  class="allTextarea"
                  style="width: calc(100% - 12px)"
                ></textarea>
              </div>
            </li>
            <li>
              <span>文件类型：</span>
              <div class="v_m" style="width: 100px">
                <allSelect
                  v-model="subscriptionData.fileType"
                  :chooseData="subfileType"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅周期：</span>
              <div>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryDay"
                  type="radio"
                  class="allRadio"
                  id="mdRadio1"
                  name="mdRadio"
                />
                <label for="mdRadio1"></label>
                <label for="mdRadio1">
                  <span class="m_l_5 m_r_20">每天</span>
                </label>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryWeek"
                  type="radio"
                  class="allRadio"
                  id="mdRadio2"
                  name="mdRadio"
                />
                <label for="mdRadio2"></label>
                <label for="mdRadio2">
                  <span class="m_l_5 m_r_20">每周</span>
                </label>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryMonth"
                  type="radio"
                  class="allRadio"
                  id="mdRadio3"
                  name="mdRadio"
                />
                <label for="mdRadio3"></label>
                <label for="mdRadio3">
                  <span class="m_l_5">每月</span>
                </label>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span style="margin-top: 7px">发送时间：</span>
              <div style="vertical-align: top">
                <!--每天-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryDay'">
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.fisthours"
                      :chooseData="$commonJs.returnHours(1)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.lastMin"
                      :chooseData="$commonJs.returnHours(2)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                </div>
                <!--每周-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryWeek'">
                  <div class="dis_line v_m m_r_10" style="width: 100px">
                    <allSelect
                      v-model="subScriTime.weekTime"
                      :chooseData="weekList"
                      :multiple="true"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.weekHours"
                      :chooseData="$commonJs.returnHours(1)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.weekMin"
                      :chooseData="$commonJs.returnHours(2)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                </div>
                <!--每月-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryMonth'">
                  <div class="m_b_10">
                    <input
                      v-model="subScriTime.isData"
                      :value="1"
                      type="radio"
                      class="allRadio"
                      id="muthRadio1"
                    />
                    <label for="muthRadio1"></label>
                    <div
                      class="d_flex m_l_5"
                      style="display: inline-flex;width: 270px"
                      v-if="parseInt(subScriTime.isTwo) === 1"
                    >
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.fistDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHours"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMin"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                      </div>
                      <div>
                        <i
                          @click="seltWeek(2)"
                          class="icon iconfont iconicon02 colorYellowF36A20"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="d_flex m_l_5"
                      style="display: inline-flex;width: 430px"
                      v-if="parseInt(subScriTime.isTwo) === 2"
                    >
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.fistDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div class="m_r_5 colorYellowF36A20">
                        <i
                          @click="seltWeek(1)"
                          class="icon iconfont iconguanbi"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                        <span class="m_l_5">&</span>
                      </div>
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.lastDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHours"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMin"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                      </div>
                      <div>
                        <i
                          @click="seltWeek(1)"
                          class="icon iconfont iconguanbi colorYellowF36A20"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="subScriTime.isData"
                      :value="2"
                      type="radio"
                      class="allRadio"
                      id="muthRadio2"
                    />
                    <label for="muthRadio2"></label>
                    <div class="d_flex m_l_5" style="display: inline-flex;width: 215px">
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.allData"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 1"
                        />
                      </div>
                      <div class="m_l_5">天</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHoursTwo"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 1"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMinTwo"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 1"
                          ></allSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </model>
    <model
      v-if="showModel4"
      :title="'正在下载'"
      :minWidth="'60%'"
      :showClose="1"
      :onButton="0"
      v-on:on-cancel="showModel4 = false"
    >
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadPercent }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadPercent + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
    <model
      v-if="showNotify"
      :onButton="2"
      :title="''"
      :minWidth="'36%'"
      v-on:on-cancel="showNotify = false"
      v-on:on-confirm="showNotify = false"
    >
      <div style="padding: 30px 40px; text-align: center">
        <img src="../../../assets/model03.png" height="60" width="60" />
        <p style="font-size: 16px; font-weight: bold; margin: 20px;">{{ notifyInfo }}</p>
      </div>
    </model>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import avatar from '@/assets/loading.gif'
let timeInever
let timeOutEml
let timeHeight
export default {
  name: 'myDnloadHomeDetail',
  components: {
    draggable
  },
  data () {
    return {
      isBtn: false,
      tableHeight: 0,
      showModel4: false,
      uploadPercent: 0,
      upName: '',
      formChildTableId: parseInt(this.$route.query.formChildTableId),
      formName: this.$route.query.formName,
      showModel: false,
      title: {
        icon: '',
        name: '搜索条件'
      },
      showModel1: false,
      title1: {
        icon: '',
        name: '自定义列'
      },
      showModel2: false,
      title2: {
        icon: '',
        name: '说明'
      },
      showModel3: false,
      title3: '',
      isGenre: 0,
      myList: {
        columns: [],
        datas: [],
        totalCount: 0,
        lastSyncTime: ''
      },
      mydbDescribe: '',
      myWideTableFilterList: [], // 可选列
      myInstructionsFilterList: [], // 可选列
      mySerchTop: [], // 顶部搜索条件
      mySerchList: [], // 搜索条件
      mySerchData: [], // 搜索入参
      mySelectedColumnList: [], // 已选列
      mySelectedColumnListTwo: [], // 已选列(未排序)
      seltFyear: '',
      seltFmouth: '',
      fileYear: [],
      fileMouth: [
        {
          id: '',
          name: '全部'
        }
      ],
      mlData: {
        isModelLeft: 0,
        topName: '',
        DbName: '',
        Dickey: '',
        isNeedPermissionControl: false,
        leftIdList: []
      },
      fileType: [
        {
          id: 1,
          name: 'excel'
        },
        {
          id: 2,
          name: 'csv'
        }
      ],
      weekList: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '周一'
        },
        {
          id: 2,
          name: '周二'
        },
        {
          id: 3,
          name: '周三'
        },
        {
          id: 4,
          name: '周四'
        },
        {
          id: 5,
          name: '周五'
        },
        {
          id: 6,
          name: '周六'
        },
        {
          id: 7,
          name: '周日'
        }
      ],
      unitList: [
        {
          id: 0,
          name: '元'
        },
        {
          id: 1,
          name: '千元'
        }
      ],
      unitSelected: 0,
      leftIndexNum: '',
      dowFileName: '',
      IsCustomize: false,
      IsHasUnit: false,
      subscriptionData: {
        id: 0,
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: '', // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选条件
        parameterJsonEn: [],
        parameterJsonList: [],
        tableId: 0,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      },
      subScriTime: {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      },
      subfileType: [
        {
          id: 1,
          name: 'excel'
        },
        {
          id: 2,
          name: 'csv'
        }
      ],
      downName: '',
      progress: 0,
      serchEamil: '',
      allEmailList: [],
      allSerchList: [],
      willNum: 0,
      newMsgTime: '',
      newTopSerch: [],
      newRightSerch: [],
      myBuData: {},
      upFileName: '',
      upFlage: 0,
      newHisId: 0,
      isBuSerch: 0,
      showNotify: false,
      notifyInfo: '',
      isCheckAll: false,
      logId: 0
    }
  },
  created () {
    this.getAllNf()
    for (let i = 1; i < 13; i++) {
      let list = {
        id: i,
        name: i < 10 ? '0' + i : i
      }
      this.fileMouth.push(list)
    }
    if (this.formChildTableId && this.formChildTableId > 0) {
      this.getWideTableFilter()
    }
  },
  mounted () {
    timeHeight = setTimeout(p => {
      this.tableHeight = window.innerHeight - document.getElementById('topSerchDiv').offsetHeight - 240
    }, 1000)
  },
  destroyed () {
    clearTimeout(timeHeight)
  },
  methods: {
    getNewBuList () {
      let data = {
        DbName: this.myBuData.dataDicTableName,
        Dickey: this.myBuData.dataDicKey,
        Keyword: '',
        TableId: this.formChildTableId,
        isNeedPermissionControl: this.myBuData.isNeedPermissionControl,
        PageIndex: 1,
        PageSize: 100
      }
      let url = this.$commonJs.returnQuery('/api/Download/GetVauleByDicKey', data)
      this.$axiox.get(url).then(msg => {
        this.upFileName = msg.data.values.join(',')
      })
    },
    returnFileName () {
      let name = ''
      for (let i = 0; i < this.mySerchTop.length; i++) {
        if (this.mySerchTop[i].columnName === 'bu') {
          console.log('this.mySerchTop[i].valueData: ' + this.mySerchTop[i].valueData)
          if (this.mySerchTop[i].valueData !== '') {
            name = this.mySerchTop[i].valueData + '-' + this.formName
          }
          if (this.mySerchTop[i].valueData === '') {
            name = this.upFileName + '-' + this.formName
          }
        }
      }
      return name
    },
    // 根据搜索获取邮箱
    seltEmail () {
      clearTimeout(timeOutEml)
      timeOutEml = setTimeout(p => {
        this.getAllEmail()
      }, 1000)
    },
    pickEmail (item, type) {
      if (parseInt(type) === 1) {
        this.subscriptionData.subscribeEmails.push(item)
        this.allEmailList = []
        this.serchEamil = ''
      } else {
        if (this.$commonJs.returnDigit(this.serchEamil, 'email', '请输入正确的邮箱')) {
          this.serchEamil = ''
          return
        }
        this.subscriptionData.subscribeEmails.push(this.serchEamil)
        this.serchEamil = ''
      }
    },
    eraseEmail (index) {
      this.subscriptionData.subscribeEmails.splice(index, 1)
    },
    getAllEmail () {
      this.$axiox.get('/api/Role/SearchEmail?email=' + this.serchEamil, '', true).then(msg => {
        this.allEmailList = msg.data || []
      })
    },
    // 获取宽表条件接口
    getWideTableFilter () {
      this.$axiox.get('/api/Download/GetWideTableFilter?tableid=' + this.formChildTableId).then(msg => {
        this.myWideTableFilterList = msg.data || []
        this.myInstructionsFilterList = JSON.parse(JSON.stringify(this.myWideTableFilterList))
        this.myInstructionsFilterList = this.myInstructionsFilterList.sort((a, b) => { return a.order - b.order })
        this.newMsgTime = msg.newestTime
        this.mydbDescribe = msg.dbDescribe
        this.dowFileName = msg.fileName
        this.IsCustomize = msg.isCustomize
        this.IsHasUnit = msg.isHasUnit
        this.unitSelected = msg.defaultUnit
        console.log(this.IsCustomize)
        this.allSerchList = []
        for (let i = 0; i < this.myWideTableFilterList.length; i++) {
          if (this.myWideTableFilterList[i].columnName === 'bu') {
            this.myBuData = this.myWideTableFilterList[i]
            this.isBuSerch = 1
          }
          this.$set(this.myWideTableFilterList[i], 'isOpenClick', false)
          this.isCheckAll = false
          if (this.myWideTableFilterList[i].isMustFilter) {
            this.allSerchList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
            this.allSerchList = this.allSerchList.sort((a, b) => { return a.order - b.order })
            // this.mySerchList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          }
          if (this.myWideTableFilterList[i].isMustShow) {
            this.myList.columns.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i].displayColumnName)))
            this.mySerchData.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
            this.$set(this.myWideTableFilterList[i], 'isOpenClick', true)
            this.mySelectedColumnList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
            this.mySelectedColumnListTwo.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          }
        }
        this.willNum = parseInt(this.mySelectedColumnListTwo.length)
        for (let i = 0; i < this.allSerchList.length; i++) {
          this.$set(this.allSerchList[i], 'valueData', '')
          this.$set(this.allSerchList[i], 'valueDataMd', [])
          this.$set(this.allSerchList[i], 'startTime', '')
          this.$set(this.allSerchList[i], 'endTime', '')
          this.$set(this.allSerchList[i], 'timeRangeType', '')
          this.$set(this.allSerchList[i], 'childList', [])
          if (this.allSerchList[i].displayColumnName === '年' || this.allSerchList[i].columnName === 'year') {
            this.allSerchList[i].valueData = this.$commonJs.returnDate(msg.newestTime, 'YY').toString()
            this.allSerchList[i].childList = [
              {
                id: this.$commonJs.returnDate(msg.newestTime, 'YY').toString(),
                name: this.$commonJs.returnDate(msg.newestTime, 'YY').toString()
              }
            ]
          }
          if (this.allSerchList[i].displayColumnName === '月') {
            if (!msg.newestTime || msg.newestTime.length > 4) {
              this.allSerchList[i].valueData = this.$commonJs.returnDate(msg.newestTime, 'MM').toString()
              this.allSerchList[i].childList = [
                {
                  id: this.$commonJs.returnDate(msg.newestTime, 'MM').toString(),
                  name: this.$commonJs.returnDate(msg.newestTime, 'MM').toString()
                }
              ]
            } else {
              this.allSerchList[i].valueData = ''
              this.allSerchList[i].childList = [
                {
                  id: '',
                  name: '全部'
                }
              ]
            }
          }
          if (this.allSerchList[i].isAbove) {
            this.mySerchTop.push(JSON.parse(JSON.stringify(this.allSerchList[i])))
          }
          if (!this.allSerchList[i].isAbove) {
            this.mySerchList.push(JSON.parse(JSON.stringify(this.allSerchList[i])))
          }
        }
        this.newTopSerch = this.mySerchTop.map(p => { return p.columnName })
        this.newRightSerch = this.mySerchList.map(p => { return p.columnName })
        if (parseInt(this.isBuSerch) === 1) {
          this.getNewBuList()
          // this.returnFileName()
        }
      })
    },
    checkMove () { },
    clkModel (type) {
      if (parseInt(type) === 1) {
        this.mlData.isModelLeft = 0
        this.showModel = true
        this.leftIndexNum = ''
      } else if (parseInt(type) === 2) {
        this.showModel1 = true
      } else if (parseInt(type) === 3) {
        this.showModel2 = true
      }
    },
    // 全选
    seltAllWide () {
      if (this.isCheckAll) {
        for (let i = 0; i < this.myWideTableFilterList.length; i++) {
          if (!this.myWideTableFilterList[i].isMustShow) {
            this.$set(this.myWideTableFilterList[i], 'isOpenClick', true)
            this.mySelectedColumnList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
            this.mySelectedColumnListTwo.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          }
        }
      } else {
        for (let i = 0; i < this.myWideTableFilterList.length; i++) {
          if (!this.myWideTableFilterList[i].isMustShow) {
            this.$set(this.myWideTableFilterList[i], 'isOpenClick', false)
            for (let j = 0; j < this.mySelectedColumnList.length; j++) {
              if (this.mySelectedColumnList[j].columnName === this.myWideTableFilterList[i].columnName) {
                this.mySelectedColumnList.splice(j, 1)
                j--
              }
            }
            for (let k = 0; k < this.mySelectedColumnListTwo.length; k++) {
              if (this.mySelectedColumnListTwo[k].columnName === this.myWideTableFilterList[i].columnName) {
                this.mySelectedColumnListTwo.splice(k, 1)
                k--
              }
            }
          }
        }
      }
    },
    seltWide (item, index) {
      if (item.isOpenClick) {
        this.mySelectedColumnList.push(JSON.parse(JSON.stringify(item)))
        this.mySelectedColumnListTwo.push(JSON.parse(JSON.stringify(item)))
      } else {
        for (let i = 0; i < this.mySelectedColumnList.length; i++) {
          if (this.mySelectedColumnList[i].columnName === item.columnName) {
            this.mySelectedColumnList.splice(i, 1)
            i--
          }
        }
        for (let i = 0; i < this.mySelectedColumnListTwo.length; i++) {
          if (this.mySelectedColumnListTwo[i].columnName === item.columnName) {
            this.mySelectedColumnListTwo.splice(i, 1)
            i--
          }
        }
      }
      let flag = true
      for (let i = 0; i < this.myWideTableFilterList.length; i++) {
        if (!this.myWideTableFilterList[i].isOpenClick) {
          flag = false
        }
      }
      if (flag) {
        this.isCheckAll = true
      } else {
        this.isCheckAll = false
      }
    },
    seltDefaultSort () {
      this.mySelectedColumnList = this.mySelectedColumnList.sort((a, b) => { return a.order - b.order })
    },
    resetSort () {
      this.mySelectedColumnList = []
      this.mySelectedColumnListTwo = []
      this.allSerchList = []
      this.mySerchData = []
      for (let i = 0; i < this.myWideTableFilterList.length; i++) {
        this.$set(this.myWideTableFilterList[i], 'isOpenClick', false)
        if (this.myWideTableFilterList[i].isMustFilter) {
          this.allSerchList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          this.allSerchList = this.allSerchList.sort((a, b) => { return a.order - b.order })
        }
        if (this.myWideTableFilterList[i].isMustShow) {
          this.$set(this.myWideTableFilterList[i], 'isOpenClick', true)
          this.mySerchData.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          this.mySelectedColumnList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
          this.mySelectedColumnListTwo.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
        }
      }
    },
    confColumn () {
      for (let i = 0; i < this.mySerchTop.length; i++) {
        if (this.newTopSerch.indexOf(this.mySerchTop[i].columnName) < 0) {
          this.mySerchTop.splice(i, 1)
          i--
        }
      }
      for (let i = 0; i < this.mySerchList.length; i++) {
        if (this.newRightSerch.indexOf(this.mySerchList[i].columnName) < 0) {
          this.mySerchList.splice(i, 1)
          i--
        }
      }
      let list = []
      let newTopSerch = []
      let newRightSerch = []
      for (let i = 0; i < this.mySelectedColumnListTwo.length; i++) {
        let num = 0
        for (let j = 0; j < this.allSerchList.length; j++) {
          if (this.allSerchList[j].id === this.mySelectedColumnListTwo[i].id) {
            num++
          }
        }
        if (num === 0) {
          list.push(JSON.parse(JSON.stringify(this.mySelectedColumnListTwo[i])))
        }
      }
      // console.log(list)
      for (let i = 0; i < list.length; i++) {
        this.$set(list[i], 'valueData', '')
        this.$set(list[i], 'valueDataMd', [])
        this.$set(list[i], 'startTime', '')
        this.$set(list[i], 'endTime', '')
        this.$set(list[i], 'timeRangeType', '')
        this.$set(list[i], 'childList', [])
        if (list[i].isAbove) {
          newTopSerch.push(JSON.parse(JSON.stringify(list[i])))
        }
        if (!list[i].isAbove) {
          newRightSerch.push(JSON.parse(JSON.stringify(list[i])))
        }
      }
      this.mySerchTop = this.mySerchTop.concat(JSON.parse(JSON.stringify(newTopSerch)))
      this.mySerchList = this.mySerchList.concat(JSON.parse(JSON.stringify(newRightSerch)))
      // console.log(this.mySerchTop)
      // console.log(this.mySerchList)
      this.mySerchTop = this.$commonJs.returnHeavy(this.mySerchTop, 'columnName')
      this.mySerchList = this.$commonJs.returnHeavy(this.mySerchList, 'columnName')
      this.mySerchTop = this.mySerchTop.sort((a, b) => { return a.order - b.order })
      this.mySerchList = this.mySerchList.sort((a, b) => { return a.order - b.order })
      this.mySerchData = JSON.parse(JSON.stringify(this.mySelectedColumnList))
      // if (this.willNum === this.mySelectedColumnListTwo.length) {
      // } else if (this.willNum < this.mySelectedColumnListTwo.length) {
      //   // console.log(this.mySerchTop)
      //   // console.log(this.mySerchList)
      //   // console.log(this.mySelectedColumnListTwo)
      //   // console.log(list)
      //   for (let i = 0; i < list.length; i++) {
      //     this.$set(list[i], 'valueData', '')
      //     this.$set(list[i], 'valueDataMd', [])
      //     this.$set(list[i], 'startTime', '')
      //     this.$set(list[i], 'endTime', '')
      //     this.$set(list[i], 'timeRangeType', '')
      //     this.$set(list[i], 'childList', [])
      //     if (list[i].isAbove) {
      //       this.mySerchTop.push(list[i])
      //     }
      //     if (!list[i].isAbove) {
      //       this.mySerchList.push(list[i])
      //     }
      //   }
      //   this.mySerchTop = this.$commonJs.returnHeavy(this.mySerchTop, 'columnName')
      //   this.mySerchList = this.$commonJs.returnHeavy(this.mySerchList, 'columnName')
      //   this.mySerchTop = this.mySerchTop.sort((a, b) => { return a.order - b.order })
      //   this.mySerchList = this.mySerchList.sort((a, b) => { return a.order - b.order })
      //   this.mySerchData = JSON.parse(JSON.stringify(this.mySelectedColumnList))
      // }
      this.showModel1 = false
      this.showModel = true
    },
    resetSerch () {
      for (let i = 0; i < this.mySerchList.length; i++) {
        this.mySerchList[i].valueData = ''
        this.mySerchList[i].startTime = ''
        this.mySerchList[i].endTime = ''
        this.mySerchList[i].valueDataMd = []
      }
    },
    confSerch () {
      let newSerchList = []
      newSerchList = this.mySerchTop.concat(this.mySerchList)
      console.log('newSerchList', newSerchList)
      for (let i = 0; i < newSerchList.length; i++) {
        let num = 0
        for (let j = 0; j < this.mySerchData.length; j++) {
          if (parseInt(newSerchList[i].id) === parseInt(this.mySerchData[j].id)) {
            num++
          }
        }
        if (num === 0) {
          this.mySerchData.push(newSerchList[i])
        }
      }
      let list = []
      for (let i = 0; i < this.mySerchData.length; i++) {
        let data = {
          displayColumnName: this.mySerchData[i].displayColumnName,
          fieldName: this.mySerchData[i].columnName,
          isShow: false,
          values: [],
          startTime: '',
          endTime: ''
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      let postList = []
      for (let i = 0; i < this.mySelectedColumnList.length; i++) {
        let data = {
          displayColumnName: this.mySelectedColumnList[i].displayColumnName,
          fieldName: this.mySelectedColumnList[i].columnName,
          isShow: false,
          values: [],
          startTime: '',
          endTime: ''
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        postList.push(data)
      }
      for (let i = 0; i < newSerchList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (newSerchList[i].columnName === list[j].fieldName) {
            list[j].startTime = newSerchList[i].startTime
            list[j].endTime = newSerchList[i].endTime
            if (parseInt(newSerchList[i].dataDicValueCount) <= 100) {
              list[j].values = newSerchList[i].valueData ? newSerchList[i].valueData.split(',') : []
            }
            if (parseInt(newSerchList[i].dataDicValueCount) > 100) {
              list[j].values = newSerchList[i].valueDataMd.map(p => { return p.id }) || []
            }
          }
        }
      }
      list = this.$commonJs.returnHeavy(list, 'fieldName')
      for (let i = 0; i < postList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (list[j].fieldName === postList[i].fieldName) {
            list[j].isShow = true
          }
        }
      }
      // console.log(postList)
      // console.log(list)
      // return
      this.$axiox.post('/api/Download/GetSampleDataByFilter?tableId=' + this.formChildTableId + '&unit=' + this.unitSelected, list).then(msg => {
        this.myList = {
          columns: msg.data.columns || [],
          datas: msg.data.datas || [],
          totalCount: msg.data.totalCount,
          lastSyncTime: msg.data.lastSyncTime
        }
      })
    },
    // 获取年份
    getAllNf () {
      let nowYear = new Date()
      this.fileYear = []
      let startYear = 2015
      let endYear = nowYear.getFullYear() + 1
      for (let i = startYear; i <= endYear; i++) {
        let list = {
          id: i,
          name: i
        }
        this.fileYear.push(list)
      }
      this.fileYear = this.fileYear.reverse()
    },
    getValueList (item) {
      // console.log(item)
      this.mlData.isModelLeft = 0
      if (item.childList.length <= 1) {
        let data = {
          DbName: item.dataDicTableName,
          Dickey: item.dataDicKey || '',
          Keyword: '',
          TableId: this.formChildTableId,
          isNeedPermissionControl: item.isNeedPermissionControl,
          PageIndex: 1,
          PageSize: 100
        }
        let url = this.$commonJs.returnQuery('/api/Download/GetVauleByDicKey', data)
        if (item.description === '年' || item.isSingleChoice) {
          item.childList = []
        } else {
          item.childList = [
            {
              id: '',
              name: '全部'
            }
          ]
        }
        this.$axiox.get(url).then(msg => {
          let list = msg.data.values || []
          for (let i = 0; i < list.length; i++) {
            let object = {
              id: list[i],
              name: list[i]
            }
            item.childList.push(object)
          }
        })
      }
    },
    seltModel (item, index) {
      // console.log(item)
      this.mlData = {
        isModelLeft: 1,
        Table: this.formChildTableId,
        topName: item.displayColumnName,
        isNeedPermissionControl: item.isNeedPermissionControl,
        DbName: item.dataDicTableName,
        Dickey: item.dataDicKey || '',
        leftIdList: item.valueDataMd || []
      }
      this.leftIndexNum = index
      this.$refs.modelRight1.emptyId()
    },
    sletModelId (e) {
      this.mySerchList[this.leftIndexNum].valueDataMd = JSON.parse(JSON.stringify(e))
      this.mlData.isModelLeft = 0
    },
    addDownloadLog (historyId, actionName, module) {
      let logInfo = {
        id: 0,
        historyId: historyId,
        actionName: actionName,
        module: module,
        remark: '',
        isSuccess: false
      }
      this.$axiox.post('/api/SystemLog/InsertDownloadSyncLog', logInfo).then(msg => {
        this.logId = msg.data || 0
      })
    },
    // 下载
    allUpdow (type) {
      this.coverGif()
      this.upFlage = 0
      this.isBtn = true
      setTimeout(p => {
        this.isBtn = false
      }, 2000)
      let that = this
      // let dis = type === 'excel' ? 'xlsx' : 'csv'
      // this.downName = this.returnFileName() + '-' + this.$commonJs.returnDate(this.$commonJs.todayDateTime, 'newYYMMDDSSFF') + '.' + dis
      let data = {
        tableId: this.formChildTableId,
        // fileName: parseInt(this.isBuSerch) === 1 ? this.returnFileName() : this.formName,
        fileName: this.formName,
        format: type,
        unit: this.unitSelected
      }
      // for (let i = 0; i < this.mySerchList.length; i++) {
      //   let num = 0
      //   for (let j = 0; j < this.mySerchData.length; j++) {
      //     if (parseInt(this.mySerchList[i].id) === parseInt(this.mySerchData[j].id)) {
      //       num++
      //     }
      //   }
      //   if (num === 0) {
      //     let data = {
      //       displayColumnName: this.mySerchList[i].displayColumnName,
      //       fieldName: this.mySerchList[i].columnName,
      //       isShow: false,
      //       values: [],
      //       startTime: '',
      //       endTime: ''
      //       // timeRangeType: this.mySerchList[i].timeRangeType
      //     }
      //     this.mySerchData.push(data)
      //   }
      // }
      // let list = []
      // for (let i = 0; i < this.mySerchData.length; i++) {
      //   let data = {
      //     displayColumnName: this.mySerchList[i].displayColumnName,
      //     fieldName: this.mySerchData[i].columnName,
      //     isShow: true,
      //     values: [],
      //     startTime: '',
      //     endTime: ''
      //     // timeRangeType: this.mySerchList[i].timeRangeType
      //   }
      //   list.push(data)
      // }
      // for (let i = 0; i < this.mySerchList.length; i++) {
      //   for (let j = 0; j < list.length; j++) {
      //     if (this.mySerchList[i].columnName === list[j].fieldName) {
      //       list[j].startTime = this.mySerchList[i].startTime
      //       list[j].endTime = this.mySerchList[i].endTime
      //       if (parseInt(this.mySerchList[i].dataDicValueCount) <= 50) {
      //         list[j].values = this.mySerchList[i].valueData ? this.mySerchList[i].valueData.split(',') : []
      //       }
      //       if (parseInt(this.mySerchList[i].dataDicValueCount) > 50) {
      //         list[j].values = this.mySerchList[i].valueDataMd.map(p => { return p.id }) || []
      //       }
      //     }
      //   }
      // }
      let list = this.returnSerch()
      let newName = []
      for (let i = 0; i < list.length; i++) {
        let fistNum = 0
        let subset = ''
        if (list[i].values.length > 0) {
          fistNum++
        }
        if (fistNum > 0) {
          subset = list[i].displayColumnName + '：' + list[i].values.join('、')
          newName.push(subset)
        }
        let lastNum = 0
        let data = ''
        if (list[i].startTime !== '' || list[i].endTime !== '') {
          lastNum++
        }
        if (lastNum > 0) {
          data = list[i].displayColumnName + '：' + list[i].startTime + '-' + list[i].endTime
          newName.push(data)
        }
      }
      let bodyData = {
        parameterjson: newName.join(','),
        parameterList: list
      }
      // console.log(list)
      // console.log(bodyData)
      // return
      let url = this.$commonJs.returnQuery('/api/Download/DownLoadTableByFilter', data)
      this.$axiox.postTwo(url, bodyData).then(msg => {
        if (msg.data.isAboveMaxCount) {
          that.disCover()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: msg.message,
            stayTime: 5
          })
        } else if (!msg.data.isAsyncNotification) {
          // that.coverGif()
          clearInterval(timeInever)
          timeInever = setInterval(p => {
            this.$axiox.getTwo('/api/Download/CheckDownLoadState?hisId=' + msg.data.hisId).then(p => {
              console.log(p)
              if (p.data === 'DataError') {
                that.disCover()
                clearInterval(timeInever)
                this.$commonJs.alertTips({
                  type: 'error',
                  title: '失败',
                  content: '下载异常',
                  stayTime: 5
                })
              } else if (p.data === 'Success') {
                that.addDownloadLog(msg.data.hisId, '开始下载', '数据下载')
                that.downName = p.message
                that.disCover()
                clearInterval(timeInever)
                that.upFlage = 1
                that.newHisId = msg.data.hisId
              }
            })
          }, 2000)
        } else {
          that.disCover()
          // this.$commonJs.alertTips({
          //   type: 'success',
          //   title: '失败',
          //   content: msg.message,
          //   stayTime: 5
          // })
          this.notifyInfo = msg.message
          this.showNotify = true
        }
      })
    },
    confirmExport (id) {
      clearInterval(timeInever)
      let that = this
      let url = ''
      that.uploadPercent = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/Download/DownLoadFile?hisId=' + id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadPercent = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = that.downName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.updateDownloadLog(that.logId, id, '下载完成', '数据下载', false)
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            that.uploadPercent = 0
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = that.downName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.$commonJs.updateDownloadLog(that.logId, id, '下载完成', '数据下载', true)
        that.showModel4 = false
        that.uploadPercent = 0
      }
      xmlResquest.send()
    },
    seltGenre (type) {
      this.isGenre = type
      this.subscriptionData = {
        id: 0,
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: this.formName, // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选参数
        parameterJsonEn: [],
        parameterJsonList: [],
        tableId: this.formChildTableId,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      }
      let list = this.returnSerch()
      // list = list.sort((a, b) => { return a.order - b.order })
      for (let i = 0; i < list.length; i++) {
        let data = ''
        let num = 0
        if (list[i].values.length > 0) {
          num++
        }
        if (num > 0) {
          data = list[i].displayColumnName + '：' + list[i].values.join('、')
          this.subscriptionData.parameterJsonList.push(data)
        }
        let seTime = ''
        let timeNum = 0
        if (list[i].startTime !== '' || list[i].endTime !== '') {
          timeNum++
        }
        if (timeNum > 0) {
          seTime = list[i].displayColumnName + '：' + list[i].startTime + '-' + list[i].endTime
          this.subscriptionData.parameterJsonList.push(seTime)
        }
      }
      this.subscriptionData.subscribeBody = this.subscriptionData.parameterJsonList.join('\n')
      this.subscriptionData.parameterJson = this.subscriptionData.parameterJsonList.join(',')
      this.subscriptionData.parameterJsonEn = JSON.parse(JSON.stringify(list))
      this.subScriTime = {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      }
      this.serchEamil = ''
      this.allEmailList = []
      if (parseInt(type) === 2) {
        this.title3 = '发送'
      } else {
        this.title3 = '订阅'
      }
      this.showModel3 = true
    },
    seltWeek (type) {
      this.subScriTime.isTwo = type
      this.subScriTime.fistDate = ''
      this.subScriTime.lastDate = ''
    },
    confirmSuCriber () {
      if (parseInt(this.isGenre) === 1 && this.subscriptionData.subscribeName === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入订阅名称',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeEmails.length === 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择邮箱地址',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeTitle === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入邮箱标题',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeBody === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入正文',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.isGenre) === 1) {
        if (this.subscriptionData.uploadFrequency === 'EveryDay') {
          this.subscriptionData.sendTime = this.subScriTime.fisthours + ':' + this.subScriTime.lastMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryWeek') {
          let watt = this.subScriTime.weekTime !== '' ? this.subScriTime.weekTime : '1,2,3,4,5,6,7'
          this.subscriptionData.sendTime = watt + '/' + this.subScriTime.weekHours + ':' + this.subScriTime.weekMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryMonth') {
          if (parseInt(this.subScriTime.isData) === 1) {
            let wday = this.subScriTime.lastDate !== '' ? this.subScriTime.fistDate + ',' + this.subScriTime.lastDate : this.subScriTime.fistDate
            this.subscriptionData.sendTime = wday + '个工作日/' + this.subScriTime.monHours + ':' + this.subScriTime.monMin
          } else {
            this.subscriptionData.sendTime = this.subScriTime.allData + '天/' + this.subScriTime.monHoursTwo + ':' + this.subScriTime.monMinTwo
          }
        }
        // this.subscriptionData.fileName = parseInt(this.isBuSerch) === 1 ? this.returnFileName() : this.formName
        this.subscriptionData.fileName = this.formName
        this.$axiox.post('/api/Download/EditSubscribe', this.subscriptionData).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新增订阅成功',
            stayTime: 5
          })
          this.showModel3 = false
        })
      } else {
        // console.log(this.subscriptionData)
        let data = {
          sendName: '',
          sendTitle: this.subscriptionData.subscribeTitle,
          sendBody: this.subscriptionData.subscribeBody,
          sendEmails: JSON.parse(JSON.stringify(this.subscriptionData.subscribeEmails)),
          parameterJson: this.subscriptionData.parameterJson,
          tableId: this.subscriptionData.tableId,
          fileType: this.subscriptionData.fileType,
          parameterJsonEn: JSON.parse(JSON.stringify(this.subscriptionData.parameterJsonEn)),
          // fileName: parseInt(this.isBuSerch) === 1 ? this.returnFileName() : this.formName
          fileName: this.formName
        }
        this.$axiox.post('/api/Download/EditSendData', data).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '发送成功',
            stayTime: 5
          })
          this.showModel3 = false
        })
      }
    },
    returnSerch () {
      let newSerchList = []
      newSerchList = this.mySerchTop.concat(this.mySerchList)
      for (let i = 0; i < newSerchList.length; i++) {
        let num = 0
        for (let j = 0; j < this.mySerchData.length; j++) {
          if (parseInt(newSerchList[i].id) === parseInt(this.mySerchData[j].id)) {
            num++
          }
        }
        if (num === 0) {
          this.mySerchData.push(newSerchList[i])
        }
      }
      let list = []
      for (let i = 0; i < this.mySerchData.length; i++) {
        let data = {
          displayColumnName: this.mySerchData[i].displayColumnName,
          fieldName: this.mySerchData[i].columnName,
          isShow: false,
          values: [],
          startTime: '',
          endTime: '',
          order: this.mySerchData[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      let postList = []
      for (let i = 0; i < this.mySelectedColumnList.length; i++) {
        let data = {
          displayColumnName: this.mySelectedColumnList[i].displayColumnName,
          fieldName: this.mySelectedColumnList[i].columnName,
          isShow: false,
          values: [],
          startTime: '',
          endTime: ''
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        postList.push(data)
      }
      for (let i = 0; i < newSerchList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (newSerchList[i].columnName === list[j].fieldName) {
            list[j].startTime = newSerchList[i].startTime
            list[j].endTime = newSerchList[i].endTime
            if (parseInt(newSerchList[i].dataDicValueCount) <= 100) {
              list[j].values = newSerchList[i].valueData ? newSerchList[i].valueData.split(',') : []
            }
            if (parseInt(newSerchList[i].dataDicValueCount) > 100) {
              list[j].values = newSerchList[i].valueDataMd.map(p => { return p.id }) || []
            }
          }
        }
      }
      list = this.$commonJs.returnHeavy(list, 'fieldName')
      for (let i = 0; i < postList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (list[j].fieldName === postList[i].fieldName) {
            list[j].isShow = true
          }
        }
      }
      return list
    },
    // loading
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  },
  watch: {
    upFlage (value) {
      if (parseInt(value) !== 0) {
        this.confirmExport(this.newHisId)
      }
    }
  }
}
</script>

<style scoped>
.btn-back{
  position:absolute;right:30px;top:40px;
}
.btn-group{
  display:flex;
  margin-bottom:10px;
}
.btn-group .total{
  font-size:18px;
}
.btn-group .btn-export{
  background: url(../../../assets/icons/icon-down.png) no-repeat;
  background-size:28px 28px ;
  width:28px;height:28px;
  margin-left:10px;
  display:inline-block;
  cursor:pointer;
}
.btn-group .btn-notice{
  background: url(../../../assets/icons/icon-dscp.png) no-repeat;
  background-size:16px 16px ;
  width:16px;height:16px;
  margin-right:20px;
  padding-left:20px;
  display:inline-block;
  cursor:pointer;
}
.btn-group .btn-send{
  width:40px;
  line-height:28px;
  background:#fff url(../../../assets/icons/icon-send.png) 5px center no-repeat;
  background-size:16px 16px ;
  margin-right:20px;
  padding-left:30px;
  display:inline-block;
  border-radius: 8px;
  border: 1px solid #ECECEC;
  cursor:pointer;
}
.btn-group .btn-subscribe{
  width:40px;
  line-height:28px;
  background:#fff url(../../../assets/icons/icon-bell.png) 5px center no-repeat;
  background-size:16px 16px ;
  margin-right:20px;
  padding-left:30px;
  display:inline-block;
  border-radius: 8px;
  border: 1px solid #ECECEC;
  cursor:pointer;
}
.btn-group .group-lf{margin-right:auto;}
.dnlDetDivTop {
  position: relative;
  vertical-align: middle;
  width:50px;
}
.dnlDetDiv {
  display: none;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  width:50px;
  padding: 5px 0px;
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  z-index: 10;
}
.dnlDetDivTop:hover .dnlDetDiv {
  display: block;
}
.dnlDetDiv > div {
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}
.dnlDetDiv > div > button {
  background-color: transparent;
  outline: none;
  border: none;
}
.dnlDetDiv > div > button:disabled {
  background-color: transparent !important;
  color: black !important;
}
.dnlDetDiv > div:hover {
  background-color: rgba(243, 106, 32, 0.2) !important;
}
.allTable th,
.allTable td {
  max-width: 480px !important;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.linDivR {
  position: fixed;
  top: 67px;
  right: 0;
  background: linear-gradient(103.31deg, #ff5022 4.44%, #fdcb2c 100%);
  border-radius: 8px 0px 0px 8px;
  padding: 10px 5px;
  color: white;
  text-align: center;
  z-index: 10;
}
.linDivR > div {
  cursor: pointer;
}
.linDivR > div:not(:last-child) {
  padding-bottom: 10px;
  border-bottom: 1px solid white;
}
.linDivR > div:not(:first-child) {
  padding-top: 10px;
}
.ribbonDiv {
  height: 100%;
}
.ribbonDiv > div > nav {
  margin-bottom: 10px;
}
.ribbonDiv > div {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  height: calc(100% - 20px);
  padding: 10px;
}
.ribbonDiv > div > div {
  border: 1px solid #dadada;
  padding: 10px 10px 0 10px;
  height: calc(100% - 70px);
  overflow: auto;
}
.btn-sort{
  background: url('../../../assets/icons/icon-sort.png') right center no-repeat;
  background-size:16px 16px;
  padding-right:20px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myDnloadHomeDetail.vue